import React, { Children } from 'react';
const PrivacyPolicy = () => {
  return <div className="pt-32 pb-20 px-4 md:px-6" data-id="element-109">
      <div className="container mx-auto max-w-4xl" data-id="element-110">
        <h1 className="text-3xl md:text-4xl font-light mb-12 tracking-tight" data-id="element-111">
          Privacy Policy
        </h1>
        <div className="prose prose-sm max-w-none" data-id="element-112">
          <p data-id="element-113">
            <strong data-id="element-114">Last Updated:</strong> {new Date().toLocaleDateString()}
          </p>
          <section className="mt-8" data-id="element-115">
            <h2 className="text-xl font-medium mb-4" data-id="element-116">1. Introduction</h2>
            <p data-id="element-117">
              Lienov Solutions LLC ("we," "our," or "us") respects your privacy
              and is committed to protecting it through our compliance with this
              policy. This Privacy Policy describes the types of information we
              may collect from you or that you may provide when you use our AI
              ad analysis and posting tool for Facebook (the "App") and our
              practices for collecting, using, maintaining, protecting, and
              disclosing that information.
            </p>
          </section>
          <section className="mt-8" data-id="element-118">
            <h2 className="text-xl font-medium mb-4" data-id="element-119">
              2. Information We Collect
            </h2>
            <p data-id="element-120">
              We collect several types of information from and about users of
              our App, including:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-121">
              <li data-id="element-122">
                Personal information such as name, email address, and contact
                information when you register for an account.
              </li>
              <li data-id="element-123">
                Information about your Facebook advertising accounts that you
                choose to connect to our App.
              </li>
              <li data-id="element-124">
                Information about your interactions with the App, including
                usage data and preferences.
              </li>
              <li data-id="element-125">
                Technical information such as IP address, device type, browser
                type, and operating system.
              </li>
              <li data-id="element-126">
                Information you provide when you contact us for support or other
                inquiries.
              </li>
            </ul>
          </section>
          <section className="mt-8" data-id="element-127">
            <h2 className="text-xl font-medium mb-4" data-id="element-128">
              3. How We Use Your Information
            </h2>
            <p data-id="element-129">
              We use information that we collect about you or that you provide
              to us:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-130">
              <li data-id="element-131">
                To provide, maintain, and improve our App and its features.
              </li>
              <li data-id="element-132">
                To process and analyze your Facebook ad data to provide insights
                and recommendations.
              </li>
              <li data-id="element-133">
                To communicate with you about your account, updates to our App,
                or respond to your inquiries.
              </li>
              <li data-id="element-134">
                To personalize your experience and deliver content relevant to
                your interests.
              </li>
              <li data-id="element-135">
                To detect, prevent, and address technical issues or security
                threats.
              </li>
              <li data-id="element-136">
                To comply with legal obligations and enforce our terms of
                service.
              </li>
            </ul>
          </section>
          <section className="mt-8" data-id="element-137">
            <h2 className="text-xl font-medium mb-4" data-id="element-138">
              4. Disclosure of Your Information
            </h2>
            <p data-id="element-139">
              We may disclose personal information that we collect or you
              provide as described in this privacy policy:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-140">
              <li data-id="element-141">
                To contractors, service providers, and other third parties we
                use to support our business.
              </li>
              <li data-id="element-142">
                To comply with any court order, law, or legal process, including
                to respond to any government or regulatory request.
              </li>
              <li data-id="element-143">
                To enforce or apply our terms of service and other agreements.
              </li>
              <li data-id="element-144">
                If we believe disclosure is necessary or appropriate to protect
                the rights, property, or safety of Lienov Solutions LLC, our
                customers, or others.
              </li>
            </ul>
          </section>
          <section className="mt-8" data-id="element-145">
            <h2 className="text-xl font-medium mb-4" data-id="element-146">5. Data Security</h2>
            <p data-id="element-147">
              We have implemented measures designed to secure your personal
              information from accidental loss and from unauthorized access,
              use, alteration, and disclosure. All information you provide to us
              is stored on secure servers. Unfortunately, the transmission of
              information via the internet is not completely secure. Although we
              do our best to protect your personal information, we cannot
              guarantee the security of your personal information transmitted to
              our App. Any transmission of personal information is at your own
              risk.
            </p>
          </section>
          <section className="mt-8" data-id="element-148">
            <h2 className="text-xl font-medium mb-4" data-id="element-149">6. Facebook Data</h2>
            <p data-id="element-150">
              Our App connects to Facebook to analyze and post ads. When you
              connect your Facebook account, we access only the data necessary
              to provide our services in accordance with Facebook's Platform
              Policy. We do not sell your Facebook data to third parties. You
              can disconnect your Facebook account from our App at any time,
              which will stop any future data collection.
            </p>
          </section>
          <section className="mt-8" data-id="element-151">
            <h2 className="text-xl font-medium mb-4" data-id="element-152">7. Your Rights</h2>
            <p data-id="element-153">
              Depending on your location, you may have certain rights regarding
              your personal information, such as the right to:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-154">
              <li data-id="element-155">Access, correct, or delete your personal information.</li>
              <li data-id="element-156">
                Object to or restrict certain processing of your personal
                information.
              </li>
              <li data-id="element-157">
                Data portability (receiving a copy of your personal
                information).
              </li>
              <li data-id="element-158">Withdraw consent where processing is based on consent.</li>
            </ul>
            <p className="mt-4" data-id="element-159">
              To exercise these rights, please contact us using the information
              provided in the "Contact Us" section.
            </p>
          </section>
          <section className="mt-8" data-id="element-160">
            <h2 className="text-xl font-medium mb-4" data-id="element-161">8. Children's Privacy</h2>
            <p data-id="element-162">
              Our App is not intended for children under 13 years of age. We do
              not knowingly collect personal information from children under 13.
              If you are a parent or guardian and believe we have collected
              information about a child under 13, please contact us so that we
              can delete such information.
            </p>
          </section>
          <section className="mt-8" data-id="element-163">
            <h2 className="text-xl font-medium mb-4" data-id="element-164">
              9. Changes to Our Privacy Policy
            </h2>
            <p data-id="element-165">
              We may update our Privacy Policy from time to time. If we make
              material changes to how we treat our users' personal information,
              we will notify you through a notice on the App. The date the
              Privacy Policy was last revised is identified at the top of the
              page. You are responsible for periodically visiting our App and
              this Privacy Policy to check for any changes.
            </p>
          </section>
          <section className="mt-8" data-id="element-166">
            <h2 className="text-xl font-medium mb-4" data-id="element-167">10. Contact Us</h2>
            <p data-id="element-168">
              If you have any questions or concerns about this Privacy Policy or
              our data practices, please contact us at:
            </p>
            <p className="mt-4" data-id="element-169">
              Lienov Solutions LLC
              <br data-id="element-170" />
              19390 Collins Avenue, Unit 1009
              <br data-id="element-171" />
              Sunny Isles Beach, FL 33160
              <br data-id="element-172" />
              Email: nikitalienov@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;